import { PageNumberSchema, PageSizeSchema } from '@weft/types';
import type { ZapiParam, ZapiParamsMap } from '@weft/zapi-types';

const PAGE_NUMBER_QUERY_PARAMETER = {
  name: 'page',
  location: 'query',
  schema: PageNumberSchema,
} as const satisfies ZapiParam;

const PAGE_SIZE_QUERY_PARAMETER = {
  name: 'pageSize',
  location: 'query',
  schema: PageSizeSchema,
} as const satisfies ZapiParam;

export const PAGINATION_QUERY_PARAMETERS = {
  [PAGE_NUMBER_QUERY_PARAMETER.name]: PAGE_NUMBER_QUERY_PARAMETER,
  [PAGE_SIZE_QUERY_PARAMETER.name]: PAGE_SIZE_QUERY_PARAMETER,
} as const satisfies ZapiParamsMap;